module.exports = __webpack_public_path__ + "34736292/img/search-filter-icon.c4751a52.svg";